// ── Design decisions ──
// Dos botones pegados (Nuevo | Usado) en vez de un checkbox: el operador ve
// ambos estados y el activo se pinta con el teal de marca. role="radiogroup"
// con aria-checked por botón, igual que TipoIngresoControl, para que el lector
// de pantalla lo anuncie como una elección excluyente.
//
// `ambiance` (sólo el ExtractionDrawer) cambia la piel por los tokens de
// ambiance.css: dos píldoras sueltas en vez de un segmentado pegado, activo en
// teal. Sin el prop el toggle se ve exactamente igual que antes.

const IsNewToggle = ({ value, onChange, disabled = false, ambiance = false }) => {
  const opciones = [
    { v: true, label: 'Nuevo' },
    { v: false, label: 'Usado' },
  ];
  return (
    <div
      role="radiogroup"
      aria-label="Estado del artículo"
      className={
        ambiance ? 'amb-tog' : 'inline-flex overflow-hidden rounded-md border border-slate-200 text-[11px]'
      }
    >
      {opciones.map((o, i) => {
        const activo = Boolean(value) === o.v;
        return (
          <button
            key={o.label}
            type="button"
            role="radio"
            aria-checked={activo}
            disabled={disabled}
            onClick={() => !disabled && onChange(o.v)}
            className={
              ambiance
                ? `amb-tog-btn${activo ? ' amb-tog-btn--on' : ''}`
                : `px-2 py-1 transition-colors disabled:opacity-50 ${
                    i > 0 ? 'border-l border-slate-200' : ''
                  } ${
                    activo
                      ? 'bg-[var(--brand-teal-soft)] font-semibold text-slate-900'
                      : 'bg-white text-slate-500 hover:bg-slate-50'
                  }`
            }
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
};

export default IsNewToggle;
